import { Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { setTabsList } from "@/redux/modules/tabs";
import { RootState, useDispatch, useSelector } from "@/redux";
import { HOME_URL } from "@/config/config";
import type { MenuProps } from "antd";

const MoreButton = (props: any) => {
	const dispatch = useDispatch();
	const { tabsList } = useSelector((state: RootState) => state.tabs);
	const { delTabs } = props;
	const { pathname } = useLocation();
	const navigate = useNavigate();
	// close multipleTab
	const closeMultipleTab = (tabPath?: string) => {
		const newTabsList = tabsList.filter((item: any) => {
			return item.key === tabPath || item.key === HOME_URL;
		});
		dispatch(setTabsList(newTabsList));
		tabPath ?? navigate(HOME_URL);
	};

	const items: MenuProps["items"] = [
		{
			key: "1",
			label: <span>关闭当前</span>,
			onClick: () => delTabs(pathname)
		},
		{
			key: "2",
			label: <span>关闭其他</span>,
			onClick: () => closeMultipleTab(pathname)
		},
		{
			key: "3",
			label: <span>关闭全部</span>,
			onClick: () => closeMultipleTab()
		}
	];

	return (
		<Dropdown menu={{ items }} placement="bottom" arrow={{ pointAtCenter: true }} trigger={["click"]}>
			<Button className="more-button" size="small" type="primary">
				更多 <DownOutlined rev={undefined} />
			</Button>
		</Dropdown>
	);
};
export default MoreButton;
